module.exports = __webpack_public_path__ + "img/quiebrasoles.b329d69c.jpg";